import styled from "styled-components";
import 'react-datepicker/dist/react-datepicker.css';
import { PrimaryButton } from "components/Button/style";
import { Col } from "react-bootstrap";

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  margin-top: 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
`;
